export class DateTimeHelper {
  static conventServerTimeToLocalTimeString(serverTimeS: string): string {
    let serverDate = new Date(serverTimeS);
    serverDate.setHours(serverDate.getHours() - 8 - (new Date().getTimezoneOffset() / 60));
    return serverDate.toLocaleString();
  }
}
